import React, { Component } from 'react';

import PropertyGroup from './PropertyGroup';
import CreateItem from '../CreateItem';

type Props = {
  propertyGroupOptions: string[],
  propertyGroupRecords: any,
  addItemLabel: string,
  fields: any,
  handlePropertyGroupsRemove: any,
  mainLabel: string,
  record: any
};

class PropertyGroups extends Component<Props> {
  handlePropertyGroupRemove = (event, index) => {
    this.props.fields.remove(index);
    this.props.handlePropertyGroupsRemove(event, index);
  }

  render() {
    return (
      <div>
        <div style={{ fontWeight: 'bold' }}>{this.props.mainLabel}</div><br />
        {this.props.fields.length > 0 && this.props.fields.map((item, index) => {
          return (
            <div key={index} style={{ paddingTop: 15 }}>
              <PropertyGroup
                handlePropertyGroupRemove={this.handlePropertyGroupRemove}
                item={item}
                propertyGroupIndex={index}
                propertyGroupOptions={this.props.propertyGroupOptions}
                propertyGroupRecords={this.props.propertyGroupRecords}
                record={this.props.record} />
            </div>
          )
        })}
        <div style={{ paddingTop: 20 }}>
          <CreateItem fields={this.props.fields} label={this.props.addItemLabel} />
        </div>
      </div>
    )
  }
};

export default PropertyGroups;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/PropertyGroups/PropertyGroups.tsx